module.exports = __webpack_public_path__ + "files/7c75b8f496918bd8c902555cdcf412d5.svg";